// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Accordion/Basic.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Accordion, AccordionItem, view, css} from '@sail/ui';
import {PanelExample} from './PanelExample';

export const Basic = () => {
  return (
    <view.div
      css={{
        background: 'surface',
        minWidth: css.value('500px'),
      }}
    >
      <Accordion>
        <AccordionItem title="Apples">
          <PanelExample />
        </AccordionItem>
        <AccordionItem title="Bananas">
          <PanelExample />
        </AccordionItem>
        <AccordionItem title="Peaches" subtitle="A subtitle can be provided">
          <PanelExample />
        </AccordionItem>
      </Accordion>
    </view.div>
  );
};
